import { z } from "zod";

/**
 * Model route bound capabilities, mirroring the hub's model_routes.bound_capability.
 */
export const modelRouteBoundCapabilities = ["hard_bound", "soft_bound", "disabled"] as const;
export const modelRouteBoundCapabilitySchema = z.enum(modelRouteBoundCapabilities);
export type ModelRouteBoundCapability = z.infer<typeof modelRouteBoundCapabilitySchema>;

/**
 * One model route, as `GET /api/v1/projects/:id/model-routes` returns it.
 */
export const modelRouteSchema = z.object({
  id: z.uuid(),
  projectId: z.uuid(),
  name: z.string().min(1),
  provider: z.string().min(1),
  model: z.string().min(1),
  pricingVersion: z.string().min(1),
  credentialRefId: z.uuid(),
  boundCapability: modelRouteBoundCapabilitySchema,
});
export type ModelRoute = z.infer<typeof modelRouteSchema>;

export const modelRouteListSchema = z.array(modelRouteSchema);
export type ModelRouteList = z.infer<typeof modelRouteListSchema>;

/**
 * `POST /api/v1/projects/:id/model-routes` creates a project-scoped model route.
 * The credential_ref_id must reference an active `model-key` credential for the same provider.
 * The name must be unique within the project.
 */
export const createModelRouteSchema = z
  .object({
    name: z.string().trim().min(1).max(80),
    provider: z.string().min(1),
    model: z.string().min(1),
    pricingVersion: z.string().min(1),
    credentialRefId: z.uuid(),
    boundCapability: modelRouteBoundCapabilitySchema.default("hard_bound"),
  })
  .strict();
export type CreateModelRoute = z.infer<typeof createModelRouteSchema>;
